import React, { Fragment } from 'react'
import { Intro, Slideshow, slideTypes, slideTextTypes } from 'cvs-core'
import img1 from '../../assets/images/U2-T1-1-1a_R.svg'
import img2 from '../../assets/images/U2-T1-1-1b_D.svg'
import img3 from '../../assets/images/U2-T1-1-1c_L.svg'
import img4 from '../../assets/images/U2-T1-1-1d_R.svg'

import voAudio1 from '../../assets/vo/CVS-HS-SPM-Prepare-01-01.mp3'
import voAudio2 from '../../assets/vo/CVS-HS-SPM-Prepare-01-02.mp3'
import voAudio3 from '../../assets/vo/CVS-HS-SPM-Prepare-01-03.mp3'
import voAudio4 from '../../assets/vo/CVS-HS-SPM-Prepare-01-04.mp3'

const data = [
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 4.5,
    panDirection: 'right',
    image: img1,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Vaping Can Be Harmful',
    },
    vo: {
      sources: [
        {
          src: voAudio1,
        },
      ],
      transcript:
        'You know that vaping can be harmful to your developing brain and body.',
    },
  },
  {
    SlideType: slideTypes.VerticalPan,
    duration: 5.5,
    panDirection: 'top',
    image: img2,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'How Can You Stay Vape Free?',
    },
    vo: {
      sources: [
        {
          src: voAudio2,
        },
      ],
      transcript:
        'But once you know the risks, what can you do to help yourself and others stay vape free?',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 8.3,
    panDirection: 'left',
    image: img3,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Vaping on social media',
    },
    vo: {
      sources: [
        {
          src: voAudio3,
        },
      ],
      transcript:
        'In this module, you will learn some of the “tricks” used by e-cigarette companies and social media that keep you exposed to vaping.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 8,
    panDirection: 'right',
    image: img4,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Stay Vape Free!',
    },
    vo: {
      sources: [
        {
          src: voAudio4,
        },
      ],
      transcript:
        'You will also learn how you can control your social media experience and other resources that can help you and others be vape free!',
    },
  },
]

export default {
  title: 'How Can I Stay Vape Free?',
  path: '/prepare/how-can-i-stay-vape-free',
  content: (
    <Fragment>
      <Intro
        title="How Can I Stay Vape Free?"
        direction="Select the play button below to begin."
        // lead=""
        // img={image}
      />
      <Slideshow slides={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Setup.js